import {
  FETCH_GROWTH_PLAN_COMPANY_DETAILS_REQUEST,
  FETCH_GROWTH_PLAN_COMPANY_DETAILS_SUCCESS,
  FETCH_GROWTH_PLAN_COMPANY_DETAILS_FAILURE,
  SUBMIT_GOALS_DETAILS_REQUEST,
  SUBMIT_GOALS_DETAILS_SUCCESS,
  SUBMIT_GOALS_DETAILS_FAILURE,
  CONFIRM_GOALS_DETAILS_REQUEST,
  CONFIRM_GOALS_DETAILS_SUCCESS,
  CONFIRM_GOALS_DETAILS_FAILURE,
  RESET_GROWTH_PLAN_ASSESSMENT,
  FETCH_GROWTH_PLAN_ASSESSMENT_LIST_REQUEST,
  FETCH_GROWTH_PLAN_ASSESSMENT_LIST_SUCCESS,
  FETCH_GROWTH_PLAN_ASSESSMENT_LIST_FAILURE,
  MARK_AND_UPDATE_GROWTH_PLAN_ASSESSMENT,
  FETCH_GOALS_LIST
} from "./types";

const initialState = {
  isCompanyDetailsLoading: true,
  companyDetailsError: "",
  companyDetails: null,
  isGoalsSubmitting: false,
  goalsSubmissionError: "",
  isGoalConfirming: false,
  goalConfirmationError: "",
  isGrowthPlanAssessmentListLoading: false,
  growthPlanAssessmentListError: "",
  growthPlanAssessmentList: [],
  totalPage: 0,
  goalsOptions: [],
  loadingMessage: ""
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GROWTH_PLAN_COMPANY_DETAILS_REQUEST:
      return {
        ...state,
        isCompanyDetailsLoading: true,
        companyDetailsError: "",
        goalsSubmissionError: "",
        goalConfirmationError: "",
        loadingMessage: "Fetching company insights from Alacriti Intelligence"
      };
    case FETCH_GROWTH_PLAN_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        isCompanyDetailsLoading: false,
        companyDetails: action.payload,
        companyDetailsError: ""
      };
    case FETCH_GROWTH_PLAN_COMPANY_DETAILS_FAILURE:
      return {
        ...state,
        isCompanyDetailsLoading: false,
        companyDetails: null,
        companyDetailsError: action.payload,
        loadingMessage: ""
      };

    case SUBMIT_GOALS_DETAILS_REQUEST:
      return {
        ...state,
        isGoalsSubmitting: true,
        goalsSubmissionError: "",
        loadingMessage: "Alacriti Intelligence is preparing your Growth Plan"
      };

    case SUBMIT_GOALS_DETAILS_SUCCESS:
      return {
        ...state,
        isGoalsSubmitting: false,
        companyDetails: action.payload,
        goalsSubmissionError: ""
      };

    case SUBMIT_GOALS_DETAILS_FAILURE:
      return {
        ...state,
        isGoalsSubmitting: false,
        goalsSubmissionError: action.payload,
        loadingMessage: ""
      };
    case CONFIRM_GOALS_DETAILS_REQUEST:
      return {
        ...state,
        isGoalConfirming: true,
        goalConfirmationError: "",
        loadingMessage: "Alacriti Intelligence is generating your Growth Plan Report"
      };
    case CONFIRM_GOALS_DETAILS_SUCCESS:
      return {
        ...state,
        isGoalConfirming: false,
        goalConfirmationError: ""
      };
    case CONFIRM_GOALS_DETAILS_FAILURE:
      return {
        ...state,
        isGoalConfirming: false,
        goalConfirmationError: action.payload,
        loadingMessage: ""
      };

    case RESET_GROWTH_PLAN_ASSESSMENT:
      return {
        ...initialState,
        isCompanyDetailsLoading: false
      };

    case FETCH_GROWTH_PLAN_ASSESSMENT_LIST_REQUEST:
      return {
        ...state,
        isGrowthPlanAssessmentListLoading: true
      };
    case FETCH_GROWTH_PLAN_ASSESSMENT_LIST_SUCCESS:
      return {
        ...state,
        isGrowthPlanAssessmentListLoading: false,
        growthPlanAssessmentList: action.payload?.assessmentlist || [],
        totalPage: action.payload.totalPage,
        growthPlanAssessmentListError: ""
      };
    case FETCH_GROWTH_PLAN_ASSESSMENT_LIST_FAILURE:
      return {
        ...state,
        isGrowthPlanAssessmentListLoading: false,
        growthPlanAssessmentList: [],
        totalPage: 0,
        growthPlanAssessmentListError: action.payload
      };
    case MARK_AND_UPDATE_GROWTH_PLAN_ASSESSMENT:
      return {
        ...state,
        growthPlanAssessmentList: state.growthPlanAssessmentList.map((assessment) => {
          if (assessment.assessment_id === action.payload) {
            return {
              ...assessment,
              is_verified: !assessment.is_verified
            };
          }
          return assessment;
        })
      };

    case FETCH_GOALS_LIST:
      return {
        ...state,
        goalsOptions: action.payload
      };

    default:
      return state;
  }
};

export default reducer;
